import { ErrorHandler, Injectable } from '@angular/core';
import { faro } from '@grafana/faro-web-sdk';

/**
 * Reports unhandled Angular errors to Grafana Faro and the browser console.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
	/**
	 * Handles an unhandled application error.
	 *
	 * @param {unknown} error - The thrown error value.
	 * @return {void} No return value.
	 */
	public handleError(error: unknown): void {
		if (faro.api) {
			const normalizedError = error instanceof Error ? error : new Error(String(error));
			faro.api.pushError(normalizedError);
		}

		console.error(error);
	}
}
